"use client";
import Link from "next/link";

import { useStep } from "@/app/abertura-de-vagas/[cargoId]/confirmar-dados/context/step-context";
import { Button } from "@/components/atoms/button/button";
import { useLocalStorage } from "@/hooks/useLocalStorage";

import { useOngoingSessionContext } from "./context";

const initialValues = {
  seniorityIds: {
    senior: "",
    middle: "",
    junior: "",
  },
  level: "",
  cargoId: "",
  cargoName: "",
  alias: "",
  professionalExperienceTime: "",
  workingModel: [],
  typeOfContract: [],
  contract: "",
  education: "",
  state: "",
  city: "",
  languages: [],
  companyName: "",
  segment: "",
  confidentialJob: false,
  hardSkills: [],
  softSkills: [],
  responsibilities: "",
  minSalary: 0,
  maxSalary: 0,
  product: "",
  experienceLevel: "",
};

export default function OngoingSessionActions() {
  const { setOpen, values, setValues } = useOngoingSessionContext();
  const { clearCompletedSteps } = useStep();

  const [, setFormDataContext] = useLocalStorage(
    "abertura-de-vagas-form-data",
    {},
  );

  return (
    <div className="flex flex-col justify-center gap-4 sm:flex-row-reverse">
      <Button
        asChild
        color="primary"
        rounded="full"
        onClick={() => {
          setOpen(false);
        }}
      >
        <Link href={`/abertura-de-vagas/${values.cargoId}/confirmar-dados`}>
          Continuar Busca
        </Link>
      </Button>
      <Button
        asChild
        variant="secondary"
        rounded="full"
        onClick={() => {
          setOpen(false);
          clearCompletedSteps();
          setFormDataContext(initialValues);
          setValues({ cargoId: "", name: "", step: 0 });
        }}
      >
        <Link href="/abertura-de-vagas">Iniciar nova pesquisa</Link>
      </Button>
    </div>
  );
}
